import {
    Button,
    LoadingSpinner,
    TermsOfService as ToS,
    PageAlert,
    Pricing,
    //GoogleBusinessProfile,
    // MockBrowserForm,
    Feature,
    FeatureList,
} from "@xapp/components";

import React, { FC, useCallback, useEffect, useState } from "react";

import { ClientApp } from "models";

import { Product } from "utils/getProducts";

import { Coupon } from "utils/getCoupons";
// import { buildDefaultFormTheme } from "utils/generateFormWidgetInput";

import { OnboardingProps } from "../models";

import classes from "./style.scss";

export interface TermsOfService {
    content: { rendered: string };
    link: string;
    modified_gmt: string;
    accepted?: boolean;
}

export interface CheckoutStepProps {
    /**
     * Error message to display to the user if something goes wrong.
     */
    error?: { error: string; message: string };
    /**
     * If we are gathering information for checkout
     */
    loading?: boolean;
    /**
     * Message to display while loading
     */
    loadingMessage?: string;
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * App that the subscription will be applied to
     */
    app: Pick<ClientApp, "name" | "appId" | "organizationId" | "website" | "places" | "leadsContact">;
    /**
     * Properties to create the app
     */
    createProps: OnboardingProps;
    /**
     * Selected product
     */
    product?: Product;
    /**
     * Optional partner, used to customize features in some cases.
     */
    partner?: string;
    /**
     * Optional coupon to apply
     */
    coupon?: Coupon;
    /**
     * Disable trial period and charge immediately
     */
    noTrial?: boolean;
    /**
     * Does the current tier support integrations
     */
    integrationsSupported?: boolean;
    /**
     * Terms of Service the user may or may not have already accepted
     *
     * If not provided, the user will not be asked to accept terms of service
     */
    termsOfService?: TermsOfService;
    /**
     * User has requested to clear the coupon, typically because of error.
     */
    onClearCoupon?(): void;
    /**
     * User has accepted the terms of service
     */
    onAcceptTermsOfService?(): void;
    /**
     * User requests to checkout
     */
    onCheckout(): void;
}

/**
 * Display terms and checkout (optional)
 */
export const CheckoutStep: FC<CheckoutStepProps> = (props) => {
    const {
        //  app,
        className,
        coupon,
        createProps,
        error,
        integrationsSupported,
        loading,
        loadingMessage,
        noTrial,
        onAcceptTermsOfService,
        onCheckout,
        //  partner,
        product,
        style,
        termsOfService,
    } = props;

    const trialDays = noTrial ? undefined : 30;

    const [tosAccepted, setTosAccepted] = useState<boolean>(false);

    useEffect(() => {
        setTosAccepted(termsOfService?.accepted);
    }, [termsOfService?.accepted]);

    const getContent = useCallback(() => {
        // if terms of service not accepted
        if (!tosAccepted && termsOfService) {
            return <ToS terms={termsOfService?.content?.rendered} onAccept={onAcceptTermsOfService} />;
        } else {
            // const website = app.website || createProps.website;
            // const leadsEmail = app.leadsContact || createProps.leadsContact;
            // const address = app.places?.length ? app.places[0].formattedAddress : createProps?.place?.formattedAddress; //?.length ? createProps.places[0].formattedAddress : "";
            // const productName = partner === "angi" ? product?.name.replace("XAPP AI", "Angi") : product?.name;
            // const formTheme = buildDefaultFormTheme(createProps?.primaryColor);
            // const headerColor = formTheme.standAlone.header.backgroundColor;
            // const middleColor = formTheme.standAlone.backgroundColor;
            // const footerColor = "#282c34";
            // const logo = createProps?.logo;
            // const name = createProps?.name;

            // has place
            const hasPlace = !!createProps?.place;

            const features: Feature[] = [
                {
                    // image of book online button
                    title: "Book Online Button",
                    subtitle: "Capture bookings & leads directly from Google Search & Maps.",
                    available: hasPlace,
                    availabilityText: "Your Book Online button will be live in 24-48 hours!",
                    unavailableText: "We need your Google Business Profile to get started.  You can add it later.",
                },

                {
                    title: "AI Website Chat",
                    //  subtitle: `AI powered chat to automatically answer questions and capture leads.`,
                    available: !!createProps?.website,
                    availabilityText: `Available for immediate install on ${createProps?.website}`,
                    unavailableText: "We need your website to get started.  You can add it later.",
                    // enable by adding your website
                },
                {
                    title: "AI Powered Bookings Page",
                    available: true,
                    subtitle: "Custom bookings page with your logo and colors; use on Angi, Facebook, and more.",
                    availabilityText: "Available for immediate setup.",
                },

                {
                    title: "Integrations",
                    disable: !integrationsSupported,
                    subtitle: "Send leads to your FSM or CRM",
                    available: createProps.beta?.onboarding?.leadsIntegration?.length > 0,
                    availabilityText: "Available for immediate setup.",
                },
            ];

            return (
                <div className={classes.checkoutWrapper}>
                    <div className={classes.headerImageWrapper}>
                        <img
                            alt="XAPP AI Book Online Button"
                            src="https://cdn-lhjhl.nitrocdn.com/xqrOkromeZIrcpnPzEnShNnPhdQdBmkr/assets/images/optimized/rev-24ab1d7/xapp.ai/wp-content/uploads/2024/09/blog-1.png"
                        />
                    </div>
                    {/* }
                    <div style={{ width: "100%" }}>
                        {hasPlace ? (
                            <>
                                <GoogleBusinessProfile
                                    loading={!hasPlace}
                                    place={createProps?.place}
                                    showBookOnline={true}
                                    styles={{ razzleDazzle: true }}
                                />
                                <div className={classes.descriptionWrapper}>
                                    <p>Your book online button can be live in 24 hours!</p>
                                </div>
                            </>
                        ) : (
                            <>
                                <MockBrowserForm
                                    headerColor={headerColor}
                                    middleColor={middleColor}
                                    footerColor={footerColor}
                                    browserFrameColor={footerColor}
                                    logoUrl={logo}
                                    businessName={name}
                                    overrideDisplayUrl={true}
                                    browserUrl={"//sche.dule.pro"}
                                    type={"calendar"}
                                />
                                <div className={classes.descriptionWrapper}>
                                    <p>Your new customizable booking page is available immediately after checkout. </p>
                                </div>
                            </>
                        )}
                    </div> */}

                    <Pricing
                        price={product?.price}
                        priceInCents={product?.priceInCents}
                        trialDays={trialDays}
                        coupon={coupon}
                        // clarificationText={"*No additional cost per lead"}
                        cancellationText={"**Cancel anytime"}
                    />

                    <div
                        style={{
                            padding: "20px",
                            rowGap: "10px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {/* TODO: Add button up top */}
                        <Button
                            style={{ width: "100%", height: "60px" }}
                            id="stepEnterPayment"
                            leftIcon="verified"
                            label={`Checkout Now`}
                            variation="primary"
                            onClick={onCheckout}
                        />
                        <div>
                            <img src={"/img/supported-payment-methods.png"} alt="Supported Payment Methods" />
                        </div>
                    </div>

                    <div>
                        <h3>Features</h3>

                        <FeatureList features={features} />
                    </div>
                </div>
            );
        }
    }, [
        tosAccepted,
        termsOfService,
        onAcceptTermsOfService,
        createProps?.place,
        createProps?.website,
        createProps.beta?.onboarding?.leadsIntegration?.length,
        integrationsSupported,
        product?.price,
        product?.priceInCents,
        trialDays,
        coupon,
        onCheckout,
    ]);

    return (
        <div style={{ ...style }} className={className}>
            {error ? (
                <PageAlert background="orange">
                    <p>{error.message}</p>
                    <pre style={{ overflow: "scroll" }}>{error.error}</pre>
                    {/**We need a call to action for them to get help */}
                </PageAlert>
            ) : (
                <></>
            )}
            {loading ? <LoadingSpinner loadingText={loadingMessage} /> : getContent()}
        </div>
    );
};
